import { Watermark } from '@/components';
import { isProdOnly } from '@/utils';
import type { FC, PropsWithChildren } from 'react';
import { getTargetEnvLabel } from './target-env';

export const TargetEnvIndicator: FC<PropsWithChildren> = ({ children }) => {
  // isProdOnly はあまり使いたくないが、Watermark で環境を区別するためだけであれば、許容する
  return !isProdOnly() ? (
    <Watermark
      content={getTargetEnvLabel()}
      gap={[5, 10]}
      font={{ color: 'rgba(255, 0, 0, 0.25)' }}
    >
      {children}
    </Watermark>
  ) : (
    children
  );
};
